module["exports"] = [
  "##-###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/address/postcode.js
// module id = 1534
// module chunks = 0